<template>
  <div class="navbar navbar-main navbar-expand-md navbar-light fixed-top pl-0">
    <div class="navbar-brand d-flex align-items-center">
      <a @click.prevent="openSidebar" class="navbar-nav-link sidebar-control sidebar-main-toggle">
        <template v-if="!closeSidebarIcon">
          <hamburger-icon/>
        </template>
        <template v-else>
          <paragraph-icon/>
        </template>
      </a>
      <router-link :to="{ name: 'dashboard' }" class="d-inline-block">
        <img alt="logo" src="../../../resources/images/invoice123.svg" class="brand-logo">
      </router-link>
    </div>
    <div class="navbar-collapse d-flex justify-content-center">
      <div class="mw-container">
        <span class="ml-auto mr-3"/>

        <ul class="navbar-nav flex-row">
          <s-popper
            class="nav-item d-flex"
            placement="bottom-start"
            tag="li"
            :arrow="true"
            v-if="authStore.user"
          >
            <a
              class="navbar-nav-link navbar-nav-link--user d-flex flex-row align-items-center dropdown-toggle pl-2"
              href="#"
              :class="[{ 'router-link-exact-active router-link-active text-primary': $route.name === 'company.edit' }]"
            >
              <div class="d-flex align-items-center navbar-item__border" style="padding: 5px; height: 30px;">
                <div class="position-relative">
                  <user-icon/>
                </div>

                <div class="d-none d-md-flex flex-column font-weight-midbold ml-1">
                  <span>{{ authStore.fullName }}</span>
                </div>

                <dropdown-icon class="ml-2"/>
              </div>
            </a>

            <template #popup>
              <div class="dropdown-menu">
                <router-link :to="{ name: 'admin.profile.index' }" class="dropdown-item">
                  <i>
                    <drawer-icon/>
                  </i> {{ $t('profile.manage.title') }}
                </router-link>
                <a :href="logoutUrl()" class="dropdown-item">
                  <i>
                    <door-icon/>
                  </i> {{ $t('actions.logout') }}
                </a>
              </div>
            </template>
          </s-popper>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
  import DoorIcon from '@/components/icons/door';
  import DropdownIcon from '@/components/icons/dropdown';
  import UserIcon from '@/components/icons/user';
  import { logoutUrl } from '@/api/auth';
  import ParagraphIcon from '@/components/icons/paragraph';
  import HamburgerIcon from '@/components/icons/hamburger';
  import { computed, watch, ref } from 'vue';
  import { useSidebarStore } from '@/stores/sidebar';
  import { useAuthStore } from '@/stores/auth';
  import DrawerIcon from '@/components/icons/drawer.vue';

  const sidebarStore = useSidebarStore();
  const authStore = useAuthStore();
  const closeSidebarIcon = ref(false);

  const mobileOpen = computed(() => sidebarStore.mobileOpen);

  watch(mobileOpen, (newValue) => {
    closeSidebarIcon.value = Boolean(newValue);
  });


  if (window.innerWidth > 1440) {
    sidebarStore.updateMobileOpen(true);
  }

  function openSidebar() {
    if (sidebarStore.mobileOpen === true) {
      sidebarStore.updateMobileOpen(false);
    } else {
      sidebarStore.updateMobileOpen(true);
    }
  }
</script>
